/**
 * "Notion isn't connected" (SPEC § Setup modal).
 *
 * Opened *instead of* a save when the integration is not ready, so no request is ever sent against
 * a half-configured target. The reason line is the server's (`readyReason` from #40, or
 * `details.reason` from a #47 `409`) and is rendered verbatim — the client never decides which of
 * the three setup steps is missing.
 *
 * The post preview popup stays open behind it: `Modal` stacks, and only the top dialog answers
 * Escape (§12.2).
 */

import { Modal } from '../../components';

export type NotionSetupDialogProps = {
  open: boolean;
  /** "Add your Notion integration key" / "Pick a database" / "Nothing is mapped yet". */
  reason: string | null;
  onClose: () => void;
  onOpenSettings: () => void;
};

export function NotionSetupDialog({ open, reason, onClose, onOpenSettings }: NotionSetupDialogProps) {
  return (
    <Modal
      open={open}
      size="sm"
      title="Notion isn't connected"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="table-action" onClick={onClose}>
            <span className="table-action__label">Cancel</span>
          </button>
          <button type="button" className="btn-primary" onClick={onOpenSettings}>
            Open Settings
          </button>
        </>
      }
    >
      <p>{reason ?? 'Finish the Notion setup first.'}</p>
      <p className="muted">
        Settings → Notion holds the integration key, the target database and which post fields go
        into which columns. It is a one-time setup.
      </p>
    </Modal>
  );
}

export default NotionSetupDialog;
